module.exports = __webpack_public_path__ + "static/img/courseDefault.878553d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courseDefault.png
// module id = 9rxm
// module chunks = 28